module.exports = __webpack_public_path__ + "SZ.png?a3a45f3fabf1ffb58e76eaf15cb28a6f";